import { useCallback, useRef } from 'react'
import type { CSSProperties } from 'react'
import { COLORS } from '../ui/tokens'
import { VUMeter } from './VUMeter'

interface Props { transmitting: boolean; analyser: AnalyserNode | null; disabled: boolean; onStart: () => void; onStop: () => void }

export function PTTButton({ transmitting, analyser, disabled, onStart, onStop }: Props) {
  const pressedRef = useRef(false)
  const sizeRef = useRef(140)

  const handleStart = useCallback(() => {
    if (disabled || pressedRef.current) return
    pressedRef.current = true
    onStart()
  }, [disabled, onStart])

  const handleStop = useCallback(() => {
    if (!pressedRef.current) return
    pressedRef.current = false
    onStop()
  }, [onStop])

  const wrapStyle: CSSProperties = {
    position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: sizeRef.current, height: sizeRef.current, cursor: disabled ? 'default' : 'pointer',
    WebkitTapHighlightColor: 'transparent', userSelect: 'none', WebkitUserSelect: 'none',
  }

  return (
    <div style={wrapStyle}
      onPointerDown={(e) => { e.currentTarget.setPointerCapture(e.pointerId); handleStart() }}
      onPointerUp={handleStop} onPointerLeave={handleStop} onPointerCancel={handleStop}
      onContextMenu={(e) => e.preventDefault()}
    >
      <VUMeter analyser={analyser} active={transmitting} size={sizeRef.current} activeColor={COLORS.error} idleColor={COLORS.accent} />
      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 4 }}>
        <span style={{ fontSize: transmitting ? 44 : 38, transition: 'font-size 0.1s', filter: disabled ? 'grayscale(1)' : 'none' }}>🎙️</span>
        <span style={{ fontSize: 11, color: transmitting ? '#fff' : COLORS.textSecond, fontWeight: transmitting ? 700 : 400, letterSpacing: 0.5, transition: 'color 0.1s' }}>
          {disabled ? 'Нет канала' : transmitting ? 'В ЭФИРЕ' : 'Удерживайте'}
        </span>
      </div>
    </div>
  )
}
